import { NgZone } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';

/* SAN-1572: proves Sentry end to end in a running build, in two modes, chosen by
   the `sentry-prove` query parameter once the app has bootstrapped:
     ?sentry-prove=captured  Sentry.captureException(), logs the event id.
     ?sentry-prove=uncaught  throws inside Angular's zone, so the error travels the
                             same path as a real bug (Sentry.createErrorHandler, the
                             app's ErrorHandler) and shows readable frames only if
                             the build's source maps were uploaded.
   Off in production builds (environmentName 'production'), so a link to a client
   tenant can never send a test error. Keep this file: it is the prover the
   Production Defects description points at, not dead code. */
export function runSentryProver(
  environmentName: string,
  search: string,
  zone: NgZone,
  sentry: Pick<typeof Sentry, 'captureException'> = Sentry,
): 'captured' | 'uncaught' | null {
  if (environmentName === 'production') {
    return null;
  }
  const mode = new URLSearchParams(search).get('sentry-prove');
  const stamp = new Date().toISOString();
  if (mode === 'captured') {
    const eventId = sentry.captureException(
      new Error(`SAN-1572 Sentry prover: captured error at ${stamp}`),
    );
    console.info(`SAN-1572 Sentry prover: captured event ${eventId}`);
    return mode;
  }
  if (mode === 'uncaught') {
    zone.run(() =>
      setTimeout(() => {
        throw new Error(`SAN-1572 Sentry prover: uncaught error at ${stamp}`);
      }),
    );
    return mode;
  }
  return null;
}
